export default __webpack_public_path__ + "static/slider_banner-e13196acd823583711b4134a8c9efbfa.png";